import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SNItem } from '../models/snitem';
import { SNUser } from '../models/snuser';
import { BecareService } from './becare.service';
import { PatientService } from './patient.service';
import { UserConfigService } from './user-config.service';

export class Printer {
  public id: string;
  public name: string;
}

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  private static instance: PrintService = null;
  private user: SNUser;

  private printersMap: Map<string, Printer> = new Map();

  constructor(private becare: BecareService, private patient: PatientService, private userConfig: UserConfigService) {
    this.userConfig.configLoaded.subscribe(() => {
      this.user = this.userConfig.user;
      this.loadPrinters();
    });
    if (this.userConfig.user) {
      // user already loaded
      this.loadPrinters();
    }
  }

  public static getInstance(): PrintService {
    return PrintService.instance;
  }

  get printers(): Printer[] {
    return Array.from(this.printersMap.values());
  }

  public loadPrinters() {
    this.becare.call('/fr/print/printers').subscribe(result => {
      if (result.success === true && result.printers !== undefined) {
        this.printersMap = new Map();
        result.printers.forEach(aPrinter => {
          const newPrinter = new Printer();
          Object.assign(newPrinter, aPrinter);
          this.printersMap.set(newPrinter.id, newPrinter);
        });
      }
    });
  }

  public printItem(item: SNItem, printer: Printer): Observable<boolean | string> {
    return new Observable(observer => {
      this.becare.call('/fr/print/printer/' + printer.id + '/item/' + item.id, [], '', 'post').subscribe(result => {
        if (result.success === true) {
          if (typeof result.document !== 'undefined') {
            observer.next(result.document);
          } else {
            observer.next(true);
          }
        } else {
          observer.error(result.message);
        }
      });
    });
  }

  public printTemplate(template: string, printer: Printer, payload: any): Observable<boolean | string> {
    return new Observable(observer => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/print/printer/' + printer.id + '/template/' + template, [], JSON.stringify(payload), 'post').subscribe(result => {
        if (result.success === true) {
          if (typeof result.document !== 'undefined') {
            observer.next(result.document);
          } else {
            observer.next(true);
          }
        } else {
          observer.error(result.message);
        }
      });
    });
  }
}
